import { TValidSdcColumns } from './../../sdc/sdc-columns.type';

export class SorterColumnGroupings {
  'Student Details': TValidSdcColumns[];
  'Lexile Details': TValidSdcColumns[];
  'Support Staff Details': TValidSdcColumns[];
  'Student & Parent Contact Details': TValidSdcColumns[];
  'SPED Details': TValidSdcColumns[];
  'ELL Details': TValidSdcColumns[];
  'NYSESLAT Details': TValidSdcColumns[];
  'Testing Modification Details': TValidSdcColumns[];
  'Middle School Details': TValidSdcColumns[];
  'Lowest Third Details': TValidSdcColumns[];
  'Attendance Details': TValidSdcColumns[];
  'School Wide Measure Details': TValidSdcColumns[];
  'Suspension Details': TValidSdcColumns[];
  'Graduation Details': TValidSdcColumns[];
  'Post Secondary Details': TValidSdcColumns[];
  'Threats to Grad Details': TValidSdcColumns[];
  'Course Details': TValidSdcColumns[];
  'Credit Earned And Sched In CurrSY': TValidSdcColumns[];
  'Credit Earned And Sched By Requirement': TValidSdcColumns[];
  'Credit Gap Details': TValidSdcColumns[];
  'Credit Recovery Details': TValidSdcColumns[];
  'Credit Gap Details By Requirement': TValidSdcColumns[];
  'Regents Planning Details': TValidSdcColumns[];
  'Regents Passed': TValidSdcColumns[];
  'Regents Needed for On Track': TValidSdcColumns[];
  'Remaining Regents Needed': TValidSdcColumns[];
  'Stars Scheduling Status': TValidSdcColumns[];
  'Regents Category Max Scores': TValidSdcColumns[];
  'Regents Details By Exam': TValidSdcColumns[];
  'Regents Prep Planning Details': TValidSdcColumns[];
  'Regents Prep Details By Exam': TValidSdcColumns[];
  'Supports': TValidSdcColumns[];
  'College Readiness Details': TValidSdcColumns[];
  'PSAT Details': TValidSdcColumns[];
  'ACT Details': TValidSdcColumns[];
  'SAT Details': TValidSdcColumns[];
  'Update Dates': TValidSdcColumns[];
  'Google Classroom': TValidSdcColumns[];

  // Per requirements on https://newvisions.atlassian.net/browse/PFD-7449 , keep this code until further notice.
  // 'Regents Exemptions': TValidSdcColumns[];

  constructor() {
    // Per requirements on https://newvisions.atlassian.net/browse/PFD-7449 , keep this code until further notice.

    // this['Regents Exemptions'] = [
    //   'countOfRegentsReqsNeededForExemptionCourseworkCompleted',
    //   'countOfRegentsReqsNeededForExemptionCourseworkInProgress',
    //   'countOfRegentsReqsNeededNotEligibleForExemption',
    //   'countOfRegentsExamsIdentifiedForExemption',
    //   'countOfRegentsExamsWithCourseworkCompleted',
    //   'countOfRegentsExamsWithCourseworkInProgress',
    //   'countOfRegentsExamsWithCourseworkInProgressDOE',
    //   'countOfRegentsExamsGreaterThan55',
    // ];

    this['Google Classroom'] = [
      'classroomRemoteEngagementLast5',
      'classroomRemoteEngagement',
      'classroomTotalAssignments',
      'classroomTotalEngagedAssignments',
      'classroomTotalEnrolled',
      'classroomStudentEmail',
    ];

    this['Student Details'] = [
      'status',
      'cohort',
      'seniorFlag',
      'status',
      'dischargeCode',
      'dischargeDate',
      'grade',
      'learningPreference',
      'officialClass',
      'slc',
      'sendingSchool',
      'attendedSummerSchoolInPriorSy',
      'dob',
      'ageOn1231OfCurrentSy',
      'yearOfEntry',
      'admitDate',
      'countOfAdmitsToCurrentSchool',
      'gender',
      'ethnicity',
      'tempResFlag',
      'housingStatus',
      'schoolPriorityFlag',
    ];

    this['Lexile Details'] = [
      'readingLexileTestDate',
      'readingLexileMostRecent',
      'readingRtiTier',
      'mathScaledScoreTestDate',
      'mathScaledScoreMostRecent',
    ];

    this['Support Staff Details'] = ['atsCounselor', 'atsCounselorEmail', 'guidanceCounselor', 'advisor'];
    this['Student & Parent Contact Details'] = [
      'studentEmail',
      'studentMobile',
      'homePhone',
      'homeLanguage',
      'parentEmail',
    ];

    this['SPED Details'] = [
      'iep',
      'spedProgram',
      'potentiallyEligibleForSafetyNet',
      'schoolVerifiedSafetyNetEligibility',
      'isSafetyNetEligible',
      'nysaaEligible',
    ];

    this['ELL Details'] = ['sife', 'ell', 'lepStatus'];

    this['NYSESLAT Details'] = ['nyseslatPlPriorSy', 'nyseslatPlTwoSyPrior', 'nyseslatPlThreeSyPrior', 'testOutYear'];

    this['Testing Modification Details'] = ['testingModificationsRspdReport'];

    this['Middle School Details'] = [
      'avg8thGradeGpa',
      'elaCourseMark8thGrade',
      'mathCourseMark8thGrade',
      'socialStudiesCourseMark8thGrade',
      'scienceCourseMark8thGrade',
      'elaPr7thGrade',
      'mathPr7thGrade',
      'elaPr8thGrade',
      'mathPr8thGrade',
      'avgMathElaPr8thGrade',
      'attendance8thGrade',
    ];

    this['Lowest Third Details'] = [
      'citywideLowestThird',
      'nvLowestThird',
      'overageUnderCredited',
      'mostAtRisk',
      'schoolLowestThird',
      'earned10PlusCreditsInPriorSy',
    ];

    this['Attendance Details'] = [
      'transitDistanceMiles',
      'transitTimeMinutes',
      'attendanceThreeSyPrior',
      'attendanceTwoSyPrior',
      'attendancePriorSy',
      'attendancePreviousSchoolDay',
      'attendanceYtdFilter',
      'attendanceYtd',
      'inPersonYTDAttendance',
      'remoteYTDAttendance',
      'attendanceYtdLastYear',
      'ytdAttendanceChange',
      'attendanceLast20',
      'inPersonAttendanceLast20Days',
      'remoteAttendanceLast20Days',
      'attendanceLast20MinusYtdPct',
      'numberOfDaysAbsentYtd',
      'countOfInPersonDaysAbsentYTD',
      'countOfInRemoteDaysAbsentYTD',
      'numberOfDaysAbsentLast5Days',
      'countOfInPersonDaysAbsentLast5Days',
      'countOfRemoteDaysAbsentLast5Days',
      'countOfDaysAbsentLast10Days',
      'countOfInPersonDaysAbsentLast10Days',
      'countOfRemoteDaysAbsentLast10Days',
      'numberOfDaysAbsentLast20Days',
      'countOfInPersonDaysAbsentLast20Days',
      'countOfRemoteDaysAbsentLast20Days',
      'countOfDaysAbsentThisTerm',
      'countOfInPersonDaysAbsentThisTerm',
      'countOfRemoteDaysAbsentThisTerm',
      'sepAttendance',
      'octAttendance',
      'novAttendance',
      'decAttendance',
      'janAttendance',
      'febAttendance',
      'marAttendance',
      'aprAttendance',
      'mayAttendance',
      'junAttendance',
      'percentDaysLateYtd',
      'percentDaysLatePriorSy',
    ];

    this['School Wide Measure Details'] = ['metAttdMetrics', 'metPromotionOrGradMetrics'];

    this['Suspension Details'] = ['sohoPrincipalSuspensionsYtd', 'sohoSuperintendentSuspensionsYtd'];

    this['Graduation Details'] = [
      'progressToGraduationCollegeReadiness',
      'distanceFromGraduation',
      'plannedDiplomaType',
      'plannedGraduationDate',
      'gradPlan',
      'calculatedGradPlan',
      'gradPlanWarnings',
      'plannedEndorsements',
      'plannedCreds',
      'creditsBehind',
      'regentsBehind',
    ];

    this['Post Secondary Details'] = ['progressToCunyBenchmarks'];

    this['Threats to Grad Details'] = [
      'creditGapsThreat',
      'regentsThreat',
      'courseFailureThreat',
      'attdThreat',
      'totalCountOfGradThreats',
    ];

    this['Course Details'] = [
      'currentCourses',
      'currentCourseCodes',
      'currentTeachers',
      'countOfHighPriorityCourses',
      'highPriorityCourseCodes',
      'countOfCoursesFailingMostRecentMp',
      'countOfHighPriorityCoursesFailingMostRecentMp',
      'countOfFailedCoursesInPriorSy',
      'countOfFailedCoursesInCurrentSy',
      'transcriptGradeAverage',
    ];

    this['Credit Earned And Sched In CurrSY'] = [
      'creditsEarnedPriorToCurrentSy',
      'creditsEarnedPriorToFirstEntry',
      'creditsEarnedBucketPriorToCurrSy',
      'totalCreditsEarnedToDateInCurrentSy',
      'totalCreditsEarnedCurrentSchedInCurrentSy',
      'coreCreditsEarnedToDateInCurrentSy',
      'coreCreditsEarnedCurrentSchedInCurrentSy',
      'earnedCreditsIn3Of4CoreSubjectsInCurrentSy',
    ];

    this['Credit Earned And Sched By Requirement'] = [
      'totalCreditsAttempted',
      'totalCreditsEarned',
      'totalCreditsSched',
      'creditsEarnedCurrentSchedTotal',

      'creditsEarnedElaCore',
      'creditsEarnedCurrentSchedElaCore',

      'creditsEarnedElaOther',
      'creditsEarnedCurrentSchedElaOther',

      'creditsEarnedMath',
      'creditsEarnedCurrentSchedMath',

      'creditsEarnedSsGlobal',
      'creditsEarnedCurrentSchedSsGlobal',

      'creditsEarnedSsUs',
      'creditsEarnedCurrentSchedSsUs',

      'creditsEarnedSsGovt',
      'creditsEarnedCurrentSchedSsGovt',

      'creditsEarnedSsEcon',
      'creditsEarnedCurrentSchedSsEcon',

      'creditsEarnedSsElective',
      'creditsEarnedCurrentSchedSsElective',

      'creditsEarnedSciTotal',
      'creditsEarnedCurrentSchedSciTotal',

      'creditsEarnedSciPhysical',
      'creditsEarnedCurrentSchedSciPhysical',

      'creditsEarnedSciLife',
      'creditsEarnedCurrentSchedSciLife',

      'creditsEarnedLote',
      'creditsEarnedCurrentSchedLote',

      'creditsEarnedCte',
      'creditsEarnedCurrentSchedCte',

      'creditsEarnedArt',
      'creditsEarnedCurrentSchedArt',

      'creditsEarnedPe',
      'creditsEarnedCurrentSchedPe',

      'creditsEarnedHealth',
      'creditsEarnedCurrentSchedHealth',
    ];

    this['Credit Gap Details'] = [
      'creditGapPriorityGrouping',
      'subjectsWithCreditGaps',
      'creditMaxGaps',
      'creditMaxGapsNoPlan',
      'countOfCreditGapPendingChanges',
      'pendingCourseAdditions',
      'pendingCourseAdditionsWithoutSection',
      'pendingCourseDrops',
      'gapPlansSummary',
      'hasPotentialCreditIssuesOnCurrProgram',
      'hasPotentialCreditIssuesOnTranscript',
      'hasGapPlansPastPlannedGradDate',
    ];

    this['Credit Recovery Details'] = [
      'coursesPotentiallyEligibleForCreditRecovery',
      'numberOfCoreCreditsEarnedThroughCreditRecovery',
    ];

    this['Credit Gap Details By Requirement'] = [
      'creditGapsStartTotal',
      'creditGapsTotal',
      'creditGapsNoPlanTotal',

      'creditGapsStartElaCore',
      'creditGapsElaCore',
      'creditGapsNoPlanElaCore',

      'creditGapsStartMath',
      'creditGapsMath',
      'creditGapsNoPlanMath',

      'creditGapsStartSsGlobal',
      'creditGapsSsGlobal',
      'creditGapsNoPlanSsGlobal',

      'creditGapsStartSsUs',
      'creditGapsSsUs',
      'creditGapsNoPlanSsUs',

      'creditGapsStartSsGovtEcon',
      'creditGapsSsGovtEcon',
      'creditGapsNoPlanSsGovtEcon',

      'creditGapsStartSciTotal',
      'creditGapsSciTotal',
      'creditGapsNoPlanSciTotal',

      'creditGapsStartSciPhysical',
      'creditGapsSciPhysical',
      'creditGapsNoPlanSciPhysical',

      'creditGapsStartSciLife',
      'creditGapsSciLife',
      'creditGapsNoPlanSciLife',

      'creditGapsStartLote',
      'creditGapsLote',
      'creditGapsNoPlanLote',

      'creditGapsStartCte',
      'creditGapsCte',
      'creditGapsNoPlanCte',

      'creditGapsStartArt',
      'creditGapsArt',
      'creditGapsNoPlanArt',

      'creditGapsStartPe',
      'creditGapsPe',
      'creditGapsNoPlanPe',

      'creditGapsStartHealth',
      'creditGapsHealth',
      'creditGapsNoPlanHealth',
    ];

    this['Regents Planning Details'] = [
      'countOfRegentsPassedForDiploma',
      'regentsPassedForDiploma',
      'countOfRegentsNeededForOnTrackDiploma',
      'regentsNeededForOnTrackDiploma',
      'countOfRegentsNeededForOnTrackDiplomaNotSched',
      'regentsNeededForOnTrackDiplomaNotSched',
      'allNextScheduledRegentsExams',
      'countOfRegentsSchedForNextAdmin',
      'regentsSchedForNextAdmin',
      'countOfRegentsExamsWithConclicts',
      'countOfRegentsSchedForFutureAdmin',
      'regentsSchedForFutureAdmin',
      'pastDueRegentsExams',
    ];

    this['Regents Passed'] = [
      'countOfRegentsPassedAt65PlusPriorToFirstEntry',
      'countOfRegentsPassedOf5PriorToCurrentSy',
      'countOfRegentsPassedForGrad',
      'countOfRegentsPassedAt65Of5',
      'countOfRegentsPassedAt55Of5SpedOnly',
      'countOfRegentsPassedAt65Of9',
    ];

    this['Regents Needed for On Track'] = [
      'countOfRegentsNeededForOnTrackGrad',
      'regentsNeededForOnTrackGrad',
      // 'regentsNeededForOnTrackCollegeReadiness',
    ];

    this['Remaining Regents Needed'] = [
      'regentsNeededForDiploma',
      'regentsNeededForGrad',
      'regentsNeededForCollegeReadiness',
      'regentsNeededForAdvancedRegentsDiploma',
    ];

    this['Stars Scheduling Status'] = [
      'elaExamProgressAndStarsSchedulingStatus',
      'mathExamProgressAndStarsSchedulingStatus',
      'scienceExamProgressAndStarsSchedulingStatus',
      'ssExamProgressAndStarsSchedulingStatus',
      'regents1OptionExamProgressAndStarsSchedulingStatus',
      'countOfRegentsSchedNextAdminNotInStars',
      'countOfScheduledRegentsExamsInStarsForNextAdministration',
      'regentsSchedInStarsNextAdmin',
    ];

    this['Regents Category Max Scores'] = [
      'maxScoreEnglishExams',
      'maxScoreMath',
      'maxScoreScience',
      'maxScoreSs',
      'maxScorePlusOne',
      'plusOneExamName',
    ];

    this['Regents Details By Exam'] = [
      'maxScoreCompEla',
      'attCompEla',

      'maxScoreCcEla',
      'attCcEla',
      'nvRecCcEla',
      'schedInStarsCcEla',
      'nextScheduledCcEla',

      'yearStartedHsMath',
      'maxScoreIntAlg',
      'attIntAlg',

      'maxScoreCcAlg',
      'attCcAlg',
      'nvRecCcAlg',
      'schedInStarsCcAlg',
      'nextScheduledCcAlg',

      'maxScoreOldGeom',
      'attOldGeom',

      'maxScoreCcGeom',
      'attCcGeom',
      'nvRecCcGeom',
      'schedInStarsCcGeom',
      'nextScheduledCcGeom',

      'maxScoreOldTrig',
      'attOldTrig',

      'maxScoreCcTrig',
      'attCcTrig',
      'nvRecCcTrig',
      'schedInStarsCcTrig',
      'nextScheduledCcTrig',

      'maxScoreLivingEnv',
      'attLivingEnv',
      'nvRecLivingEnv',
      'schedInStarsLivingEnv',
      'nextScheduledLivingEnv',

      'maxScoreEarth',
      'attEarth',
      'nvRecEarth',
      'schedInStarsEarth',
      'nextScheduledEarth',

      'maxScorePhysicalScience',
      'maxScoreChem',
      'attChem',
      'nvRecChem',
      'schedInStarsChem',
      'nextScheduledChem',

      'maxScorePhysics',
      'attPhysics',
      'nvRecPhysics',
      'schedInStarsPhysics',
      'nextScheduledPhysics',

      'maxScoreGlobal',
      'attGlobal',
      'nvRecGlobal',
      'schedInStarsGlobal',
      'nextScheduledGlobal',

      'maxScoreGlobalTwo',
      'attGlobalTwo',
      'nvRecGlobalTwo',
      'schedInStarsGlobalTwo',
      'nextScheduledGlobalTwo',

      'maxScoreUs',
      'attUs',
      'nvRecUs',
      'schedInStarsUs',
      'nextScheduledUs',

      'maxScoreUsFramework',
      'attUsFramework',
      'nvRecUsFramework',
      'schedInStarsUsFramework',
      'nextScheduledUsFramework',

      'maxScoreLote',
      'attLote',
      'nvRecLote',
      'schedInStarsLote',
      'nextScheduledLote',
      'nextScheduledLoteExamName',
    ];

    this['Regents Prep Planning Details'] = [
      'countOfRegentsSchedNextAdminWithNoPrep',
      'regentsSchedNextAdminWithNoPrep',
      'countOfRegentsSchedNextAdminWithCourseOnlyFailingBorderline',
      'regentsSchedNextAdminWithCourseOnlyFailingBorderline',
    ];

    this['Regents Prep Details By Exam'] = [
      'ccElaPlannedNextAdmin',
      'ccElaAlignedCourses',
      'ccElaAlignedSupports',
      'ccElaPrepStatus',

      'ccAlgPlannedNextAdmin',
      'ccAlgAlignedCourses',
      'ccAlgAlignedSupports',
      'ccAlgPrepStatus',

      'ccGeomPlannedNextAdmin',
      'ccGeomAlignedCourses',
      'ccGeomAlignedSupports',
      'ccGeomPrepStatus',

      'ccTrigPlannedNextAdmin',
      'ccTrigAlignedCourses',
      'ccTrigAlignedSupports',
      'ccTrigPrepStatus',

      'livingEnvPlannedNextAdmin',
      'livingEnvAlignedCourses',
      'livingEnvAlignedSupports',
      'livingEnvPrepStatus',

      'earthPlannedNextAdmin',
      'earthAlignedCourses',
      'earthAlignedSupports',
      'earthPrepStatus',

      'chemPlannedNextAdmin',
      'chemAlignedCourses',
      'chemAlignedSupports',
      'chemPrepStatus',

      'physicsPlannedNextAdmin',
      'physicsAlignedCourses',
      'physicsAlignedSupports',
      'physicsPrepStatus',

      'globalPlannedNextAdmin',
      'globalAlignedCourses',
      'globalAlignedSupports',
      'globalPrepStatus',

      'globalTwoPlannedNextAdmin',
      'globalTwoAlignedCourses',
      'globalTwoAlignedSupports',
      'globalTwoPrepStatus',

      'usPlannedNextAdmin',
      'usAlignedCourses',
      'usAlignedSupports',
      'usPrepStatus',

      'usFrameworkPlannedNextAdmin',
      'usFrameworkPrepStatus',
      'usFrameworkAlignedCourses',
      'usFrameworkAlignedSupports',

      'lotePlannedNextAdmin',
      'loteAlignedCourses',
      'loteAlignedSupports',
      'lotePrepStatus',
    ];

    // tslint:disable-next-line:no-string-literal
    this['Supports'] = [
      'countOfCurrentlyActiveSupports',
      'currentlyActiveSupports',
      'countOfCurrentlyActiveAcademicSupports',
      'currentlyActiveAcademicSupports',
      'countOfCurrentlyActiveAttendanceSupports',
      'currentlyActiveAttendanceSupports',
      'countOfCurrentlyActiveRegentsPrepSupports',
      'currentlyActiveRegentsPrepSupports',
    ];

    this['College Readiness Details'] = [
      'nvCunyFlag',
      'englishRegentsCr',
      'mathRegentsCr',
      'englishAndMathCr',
      'creditsEarnedCurrentSchedGeom',
      'creditsEarnedCurrentSchedAlgebra2Trig',
      'creditsEarnedCurrentSchedPrecalculus',
      'countOfApExamsWith3',
      'countOfApExams',
      'collegeReadyOnMathRegentsOrSatMath',
      'collegeReadyOnElaRegentsOrSatCr',
    ];

    this['PSAT Details'] = [
      'psatMaxScoreTotalReadingMathWriting',
      'psatMaxScoreReading',
      'psatMaxScoreMath',
      'psatMaxScoreWriting',
    ];

    this['ACT Details'] = ['maxScoreActEnglish', 'maxScoreActMath'];

    this['SAT Details'] = [
      'satMaxScoreTotalReadingMath',
      'satMaxScoreReading',
      'satMaxScoreMath',
      'satMaxScoreWriting',
    ];

    this['Update Dates'] = ['lastUpdated', 'lastUpdatedAts', 'lastUpdatedPowerSchool'];
  }
}
